<script setup lang="ts">
const p = usePortfolioStore().profile
const year = '۱۴۰۴'
</script>

<template>
  <footer class="mt-2 flex flex-wrap items-center justify-between gap-3 border-t border-line px-1 pb-3 pt-7">
    <p class="m-0 text-xs text-muted">© {{ year }} {{ p.name }} — همه‌ی حقوق محفوظ است.</p>
    <p class="m-0 text-xs text-muted">
      طراحی قالب توسط <a href="https://portify.ir" target="_blank" rel="noopener noreferrer" class="font-bold text-accent">Portify</a> — حق طراحی محفوظ است.
    </p>
  </footer>
</template>
